import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import ElementPlus from 'element-plus';
import 'element-plus/dist/index.css' // 这一步很重要

const app = createApp(App)
app.use(ElementPlus)
app.use(router).mount('#app')
